/**
 * mosaicPatterns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const mosaicPatternsPack: ToilePack = {
    slug: 'mosaic-patterns',
    category: 'mosaic',
    name: 'Mosaic patterns',
    tagline: tagline('patterns', 'designs', 'materials'),
    chips: chips('designs', 'materials'),
    ratio: SQUARE,
    readings: [
        {key: 'medallion', label: 'Roman medallion', subject: 'guilloche and key-fret bands around a rosette'},
        {key: 'koi', label: 'Koi pond', subject: 'two koi circling among lily pads and ripples'},
        {key: 'border', label: 'Geometric border', subject: 'interlocking meanders and diamonds'},
    ],
    styles: [
        {key: 'template', label: 'Cutting template', style: 'printable template, one closed cell per tessera', palette: 'black line on pure white', framing: 'flat, from directly above'},
        {key: 'ceramic', label: 'Ceramic tile', style: 'glazed square tesserae, visible grout lines', palette: 'soft glaze sheen', framing: 'flat, from directly above'},
        {key: 'pebble', label: 'Pebble mosaic', style: 'river stones set on edge in mortar', palette: 'natural greys, ochres and blacks', framing: 'flat, from directly above'},
    ],
    directions: ['a sunburst instead', 'larger tesserae, fewer pieces', 'with a wider border band'],
}
